/**
 * Created by rickborst on 01/03/2017.
 */

import _ from 'lodash';


/**
 * Parse the response from authentication with credentials request.
 *
 * @param {Object} data - Response data.
 * @returns {Object} Parsed data.
 */
export function convertFromAuthenticationWithCredentials (data) {

    return {
        token: data.ks || '',
        refreshToken: data.refreshToken || ''
    };
}

/**
 * Convert request data to Kaltura's naming.
 *
 * @param {Object} session - Session data.
 * @returns {Object} Transformed data.
 */
export function convertForAuthenticationWithRefreshToken (session) {
    return {
        ks: session.token || '',
        refreshToken: session.refreshToken || '',
        udid: this._presets.udid || ''
    };
}

/**
 * Parse the response from authentication with refresh token request.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Parsed data.
 */
export function convertFromAuthenticationWithRefreshToken (response) {
    let data = _.get(response, ['result']) || {};

    return {
        token: data.ks || '',
        refreshToken: data.refreshToken || ''
    };
}

/**
 * Convert request data to Kaltura's naming.
 *
 * @param {Object} session - Session data.
 * @returns {Object} Transformed data.
 */
export function convertForLocalStorage (session) {

    return {
        token: session.token,
        refreshToken: session.refreshToken,
        storageTimestamp: Date.now()
    };
}

/**
 * Parse the response from local storage request.
 *
 * @param {Object} data - Response data.
 * @returns {Object} Parsed data.
 */
export function convertFromLocalStorage (data) {
    data = data || {};
    return {
        token: data.token,
        refreshToken: data.refreshToken,
        storageTimestamp: data.storageTimestamp
    };
}

/**
 * Convert request data to Kaltura's naming.
 *
 * @param {Object} session - Session data.
 * @returns {Object} Transformed data.
 */
export function convertForPersistentPayload (session) {

    return {
        ks: session.token
    };
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/session.js